var services = {
  GET_GEO_DATA_BASE_URL: 'rest/model/com/decathlon/cube/geodata/actor/GeoDataActor/',
};

var selectpickers, liaisons, currentAddress;

/**
* getQueryStringParams - return a map of all url parameters
*
* @return {object}  map of parameters
*/
function getQueryStringParams () {
  var querystring = window.location.search.substring(1);
  var parameters = querystring.split('&');
  var map = {};

  for (var i = 0, l = parameters.length; i < l; i++) {
    var parameter = parameters[i];
    var keyvalue = parameter.split('=');

    map[keyvalue[0]] = keyvalue[1];
  }

  return map;
}


/**
 * addLinkActions - main function
 *
 * @return {void}
 */
function addLinkActions () {
  /* "liaisons" var is generated by ac_addressformgenerator */
  var links = liaisons || [];

  for (var i = 0, l = links.length; i < l; i++) {
    var link = links[i];
    link.triggers = link.triggers || [];

    for (var j = 0, m = link.triggers.length; j < m; j++) {
      var trigger = link.triggers[j];

      if (trigger === 'INITIAL') {
        link.api = link.api || DEFAULT_GEODATE_API;

        callGeoDataAPI(link.api, buildApiJson(link.params), link.destinations);
      }
      else {
        var field = cube.$(trigger);
        if (!field)
          return;

        (function (link) {
          field.addEventListener('change', function () {
            addEvent(link.api, link.params, link.destinations, link.triggers, link.fieldToClean);
          });
        })(link);

        // trigger event for autofill data //
        if (field.value)
          field.dispatchEvent(new CustomEvent('change'));
        else
          link.destinations.forEach(({ fieldId }) => {
            const element = cube.$(fieldId);

            if (element && element.type === 'select-one')
              element.disabled = true;
          });
      }
    }
  }
}


/**
 * addEvent - add events to a field
 *
 * @param  {string} api          the api to call
 * @param  {object} params       unformatted parameters
 * @param  {array} destinations  an array of objects
 * @param  {type} triggers       an array of elements id
 * @param  {array} fieldToClean  an array of elements id
 * @return {void}
 */
function addEvent (api, params, destinations, triggers, fieldToClean) {
  var fields = objectsToIds(destinations);
  var params = buildApiJson(params);

  cleanFields(fields);

  if (checkFieldsValidity(triggers)) {
    cleanFields(fieldToClean);
    callGeoDataAPI(api, params, destinations , triggers);
  }
}


/**
 * checkFieldsValidity - check if all the fields are valid
 *
 * @param  {array} fields an array of elements id
 * @return {boolean}
 */
 function checkFieldsValidity (fields) {
    if (!fields)
      return true;

    for (var i = 0, l = fields.length; i < l; i++) {
      var field = cube.$(fields[i]);

      if (field && !field.checkValidity())
        return false;
    }

    return true;
}


/**
 * isSelect - check if an jQuery element is a select
 *
 * @param  {jquery object} element the jQuery element to check
 * @return {boolean}
 */
function isSelect (element) {
  return element.tagName === 'SELECT';
}


/**
 * objectToIds - transform an array of objects to an array of element id
 *
 * @param  {array} array  an array of objects
 * @return {array}        an array of elements id
 */
function objectsToIds (array) {
  if (!array)
    return;

  var ids = [];

  for (var i = 0, l = array.length; i < l; i++) {
    var object = array[i];
    ids.push(object['fieldId']);
  }

  return ids;
}


/**
 * cleanFields - empty all the fields
 *
 * @param  {array} fields an array of elements id
 * @return {void}
 */
function cleanFields (fields) {
  if (!fields)
    return;

  for (var i = 0, l = fields.length; i < l; i++) {
    const field = cube.$(fields[i]);

    if (!field)
      return;

    if (isSelect(field) && !cube.$id('postalCode')) {
      // postalCode condition was added to prevent form submission in create  account when the user pushes the enter key.//
      // remove all elements except the first child //
      while (field.options.length > 1)
        field.removeChild(field.lastChild);

      field.disabled = true;

      $(field)
        .selectpicker('refresh')
        .parents('.form-group')
        .removeClass('has-error')
        .find('.has-error')
        .removeClass('has-error');

      field.dispatchEvent(new CustomEvent('change'));
    }
    else {
      field.value = '';
    }
  }
}


/**
 * buildApiJson - transform object to valid parameters object for the api
 *
 * @param  {object} params initial object
 * @return {type}          parameters object
 */
  function buildApiJson (params) {
  if (!params)
    return;

  var object = $.extend({}, params);

  for (var key in object) {
    var value = object[key];

    if(value.startsWith('#'))
      object[key] = cube.$(value).value;
  }

  return object;
}


/**
 * callGeoDataAPI - call the api and update form
 *
 * @param  {string} api          api path name
 * @param  {object} params       parameters to send to the api
 * @param  {array} destinations  an array of objects
 * @param  {type} triggers       an array of elements id
 * @return {void}
 */
function callGeoDataAPI (api, params, destinations, triggers) {
  cube.ajax.post(services.GET_GEO_DATA_BASE_URL + api, params)
    .onSuccess(function (response) {
      var data = response.responseTO.data;
      updateFormInfoFromGeoDataResponse(data, destinations, triggers);
    })
    .onError(function (e) {
      console.log("error :" + e);
    })
    .call();
}


/**
 * updateFormInfoFromGeoDataResponse - Update fields after api call
 *
 * @param  {array} data          api response
 * @param  {object} destinations an array of objects
 * @param  {type} triggers       an array of elements id
 * @return {void}
 */
function updateFormInfoFromGeoDataResponse (data, destinations, triggers) {
  var destinations = destinations || [];
  var data = data || [];

  for (var i = 0, l = destinations.length; i < l; i++) {
    var destination = destinations[i];
    var field = cube.$(destination.fieldId);
    var updated;

    if (field && checkFieldsValidity(triggers)) {
      if (isSelect(field))
        updated = updateSelectFieldWithResult(destination, data);
      else
        updated = updateInputFieldWithResult(destination, data);

      if (!updated)
        cleanFields(destinations);
    }
  }
}


/**
 * updateSelectFieldWithResult - update select options after api call
 *
 * @param  {object} destination  an object
 * @param  {array} data          api response
 * @return {boolean}             return true if the field is updated
 */
function updateSelectFieldWithResult (destination, data) {
  var field = cube.$(destination.fieldId);
  var results = data[destination.dataPath] || data;

  /* remove all element except the first child */
  while (field.options.length > 1)
    field.removeChild(field.lastChild);

  if (!results.length)
    field.disabled = true;
  else
    field.disabled = false;

  for (var i = 0, l = results.length; i < l; i++) {
    var result = results[i];
    /* "currentAddress" is generated by ac_addressformgenerator */
    var selected = currentAddress && result[destination.value] === currentAddress[destination.defaultShippingValue];
    var option = document.createElement('option');

    option.value = result[destination.value];
    option.text = result[destination.text];
    option.selected = selected;

    field.appendChild(option);
  }

  if(selectpickers) selectpickers.selectpicker('refresh');
  field.dispatchEvent(new CustomEvent('change'));

  field.addEventListener('change', triggerValidation);

  return true;
}


/**
 * updateInputFieldWithResult - update field after api call
 *
 * @param  {object} destination  an object
 * @param  {array} data          api response
 * @return {boolean}             return true if the field is updated
 */
function updateInputFieldWithResult (destination, data) {
  var field = cube.$(destination.fieldId);
  var value = destination.dataPath.split('.').reduce(function (accumulateur, value) {
    return accumulateur && accumulateur[value];
  }, data);

  if (value)
    field.value = value;

  return true;
}


/**
 * triggerValidation - trigger an event to launch jQuery validation methods
 *
 * @return {void}
 */
function triggerValidation () {
  this.dispatchEvent(new CustomEvent('blur'));
}

module.exports = {
  /**
  * initializeForm - itialize an address form
  *
  * @param  {string} countryGeoCode three letters representing a country
  * @param  {string} addressType    BILLING or SHIPPING
  * @return {void}
  */
  init: function (countryGeoCode, addressType) {
    const form = cube.$id('addressFormGenerator');
    const idAddress = cube.$id('idAddress') ? cube.$id('idAddress').value : '';

    var parameters = getQueryStringParams();
    var tokenId = parameters['tokenId'] || '';
    var tokenAction = parameters['tokenAction'] || '';

    cube.cartridge(form.id)
    .after(function () {
      var data = cube.$id('cube-form-address-data').innerHTML;
      liaisons = JSON.parse(data).liaisons || [];
      currentAddress = JSON.parse(data).address || {};

      addLinkActions();

      selectpickers = $(cube.$class('selectpicker'));
      selectpickers.selectpicker('refresh');

      if(countryGeoCode == 'ROU' && cube.$id('streetAutoComplete')){
        addressROAutocomplete();
      }
    })
    .reload({
      idAddress,
      countryGeoCode,
      addressType,
      tokenId,
      tokenAction
    });
  }
};

function addressROAutocomplete () {
  const line1 = cube.$id('line1Autocomplete');
  line1.on('keyup', function(){
    if(line1.value.length >= 3){
      const cityGeoId = cube.$id('cityGeoId').value;
      const provinceGeoId = cube.$id('provinceGeoId').value;
      const params = {
        'cityGeoId': cityGeoId,
        'line1': line1.value,
        'provinceGeoId': provinceGeoId
      };
      if(line1.value.indexOf('numar')<0){
        $.ajax({
          type: 'POST', dataType: 'json', url: '/ro/ajax/rest/model/com/decathlon/cube/geodata/actor/GeoDataActor/getStreetsFromROPartner', data: params,
          success: function(data) {
            const resultAutoComplete = cube.$id('streetAutoComplete');
            resultAutoComplete.innerHTML = "";
            const results = data.responseTO.data.data || undefined;
            if(results != undefined){
              for(let i = 0; i < results.length; i++){
                const li = document.createElement("li");
                const result = results[i].street;
                const p = document.createElement("p");
                const text = result.toLowerCase().replace(line1.value,'<span>'+line1.value+'</span>');
                p.innerHTML = text;
                li.appendChild(p);
                li.className = "resultAutoComplete";
                li.setAttribute("data-value", result);
                resultAutoComplete.appendChild(li);
              }
              jQuery('.resultAutoComplete').on('click', (e) => {
                line1.value = e.currentTarget.getAttribute('data-value') + ', numar ';
                line1.focus();
                resultAutoComplete.innerHTML = "";
                line1.removeEventListener('keyup', null);
              });
            }
          }
        });
      }
    }
    line1.removeEventListener('keyup', null);
  });

  line1.on('focusout',()=>{
    if(line1.value.length >= 4){
      if(line1.value.indexOf('numar')<0){
        line1.value += ', numar ';
        line1.focus();
      }
      const cityGeoId = cube.$id('cityGeoId').value.toString();
      const provinceGeoId = cube.$id('provinceGeoId').value.toString();
      const line = line1.value.split(', ',1).toString();
      const numar = line1.value.split('numar ',2)[1];
      const params = {
        'cityGeoId': cityGeoId,
        'provinceGeoId': provinceGeoId,
        'streetName': line,
        'streetNumber': numar
      };

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: '/ro/ajax/rest/model/com/decathlon/cube/geodata/actor/GeoDataActor/getPostalCodeFromROPartner',
        data: params,
        success: function(data) {
          const postalCode = data.responseTO.data.data[0].postalcode || 999999;
          if(postalCode === 999999){
            cube.$id('postalCode').value = cube.$id('postalCodeFallback').value;
          }else{
            cube.$id('postalCode').value = postalCode;
          }
        }
      });
    }
    line1.removeEventListener('focusout', null);
  });
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/form/lib-form-address.js